import { FormInstance } from "antd";
import type { ColumnsType } from "antd/es/table";
import { PlayCircleFilled } from "@ant-design/icons";

import cn from "../../../../utils/cn";
import { renderDecodedId } from "../../../../utils/renderDecodedId";
import { sortColumn } from "../../constants";
import { DrawerActionType } from "../../types";
import TableActions from "../components/TableActions";
import StatusBadge from "../components/StatusBadge";
import getCategoryFilters from "../utils/getCategoryFilters";
import { ShelfType, TrialContentUploadVideoType } from "../types";
import setValuesOnEdit from "./setValuesOnEdit";

export function createVideoColumns(
  data: TrialContentUploadVideoType[],
  form: FormInstance<any>,
  setModalData: React.Dispatch<
    React.SetStateAction<TrialContentUploadVideoType | undefined>
  >,
  setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>,
  setDrawerAction: React.Dispatch<React.SetStateAction<DrawerActionType>>,
  deleteVideo: any,
  refetch: any
): ColumnsType<TrialContentUploadVideoType> {
  return [
    sortColumn,
    {
      title: "Title",
      dataIndex: "videoTitle",
    },
    {
      title: "Category",
      dataIndex: "categoryName",
      width: 120,
      filters: getCategoryFilters(data),
      onFilter: (value, record) => record.categoryName === value,
    },
    {
      title: "Video",
      dataIndex: "videoUrl",
      render: (value: string, record: TrialContentUploadVideoType) => (
        <div
          className={cn("flex items-center gap-2", value ? "" : "hidden")}
          onClick={() => setModalData(record)}
        >
          <PlayCircleFilled className="text-lg" />
          <p>Watch</p>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "productVideoAndMarkets",
      width: 120,
      render: (value: ShelfType[]) => (
        <StatusBadge isActive={value.length > 0} />
      ),
    },
    {
      title: "Actions",
      dataIndex: "productVideoAndMarkets",
      width: 120,
      render: (value: ShelfType[], record: TrialContentUploadVideoType) => (
        <TableActions
          isInUse={value.length > 0}
          onEdit={() => {
            setValuesOnEdit(record, form);
            setOpenDrawer(true);
            setDrawerAction("Edit");
          }}
          onDelete={() => {
            const id = parseInt(renderDecodedId(record.id));

            deleteVideo({ variables: { productVideoId: id } })
              .then(() => refetch())
              .catch((e: any) => console.log(e));
          }}
        />
      ),
    },
  ];
}
